<template>
  <b-modal
    id="bulk-edit-modal"
    v-model="localIsOpen"
    :title="$t('bulk_edit.modal_title')"
    centered
    scrollable
    no-close-on-backdrop
    no-close-on-esc
    header-bg-variant="dark"
    header-text-variant="light"
    size="lg"
    @hidden="$emit('close')"
  >
    <p class="text-muted small mb-2">
      {{ $t('bulk_edit.only_filled_fields') }}
    </p>

    <!-- Dynamic fields -->
    <bulk-edit-fields-form
      :fields="fields"
      :form-data="formData"
      :catalog-options="catalogOptions"
    />

    <!-- Footer -->
    <template #modal-footer>
      <b-button
        variant="secondary"
        @click="$emit('close')"
        :disabled="isSubmitting"
        class="text-capitalize"
      >
        {{ $t('actions.cancel') }}
      </b-button>
      <b-button
        variant="primary"
        @click="$emit('submit')"
        :disabled="isSubmitting || !hasChanges"
        class="text-capitalize"
      >
        <b-spinner small v-if="isSubmitting" class="mr-50" />
        <span>
          {{ $t('bulk_edit.apply_changes', { count: selectedCount }) }}
        </span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { computed } from "@vue/composition-api";
import BulkEditFieldsForm from "./BulkEditFieldsForm.vue";

export default {
  name: "BulkEditModal",
  components: {
    BulkEditFieldsForm,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    selectedCount: {
      type: Number,
      default: 0,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    catalogOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const localIsOpen = computed({
      get() {
        return props.isOpen;
      },
      set(value) {
        if (!value) {
          emit("close");
        }
      },
    });

    // Empty strings count as untouched (a cleared text/number input).
    const hasChanges = computed(() => {
      return Object.values(props.formData).some(
        (v) => v !== null && v !== undefined && v !== ""
      );
    });

    return {
      localIsOpen,
      hasChanges,
    };
  },
};
</script>

<style lang="scss" scoped>
.modal-header .bg-dark {
  background-color: var(--main-dark) !important;
}
</style>
